import { makeStyles } from "@material-ui/core/styles";

export const useRichTextInputStyles = makeStyles(() => ({
  editor: {
    border: "1px solid #909090",
    padding: "5px 10px",
    borderBottomLeftRadius: "4px",
    borderBottomRightRadius: "4px",

    "&:hover": {
      "&:not($readonly)": {
        borderColor: "#000000DE",
      },
    },
  },

  focus: {
    "&:not($readonly)": {
      borderColor: "#00CAFF !important",
      borderWidth: "2px !important",
    },
  },

  hidden: {
    display: "none !important",
  },

  readonly: {
    border: "1px solid #0000001f",
    borderRadius: "4px",
    "& *": {
      userSelect: "none",
    },
  },

  toolbar: {
    borderColor: "#909090 !important",
    marginBottom: "0 !important",
    borderRadius: "0 !important",
    borderBottom: "0 !important",
    borderTopLeftRadius: "4px !important",
    borderTopRightRadius: "4px !important",
  },
}));
